import { createTheme } from '@mui/material/styles'
import unoTheme from './unoTheme'

let theme = createTheme(unoTheme, {
  typography: {
    h1: {
      textTransform: 'uppercase',
      fontWeight: 900
    },
    h2: {
      textTransform: 'uppercase',
      fontWeight: 900
    },
    h3: {
      textTransform: 'uppercase',
      fontWeight: 700
    },
    h4: {
      fontWeight: 700
    },
    h5: {
      fontWeight: 700
    },
    h6: {
      textTransform: 'uppercase',
      fontWeight: 700
    }
  },
  zIndex: {
    // Olark widget z-index is 9000000. This one goes to 11!
    snackbar: 9000011
  }
})

export default theme
